import { safeStorage } from "@/utils/safeStorage";

export const EMERALD_NOTE_SEEN_KEY = "emeraldNoteSeen";

/**
 * Mark the Midnight Emerald announcement as seen without showing it.
 * Called on registration: brand-new users never experienced the theme
 * change the note announces.
 */
export function suppressEmeraldNote() {
  safeStorage.set(EMERALD_NOTE_SEEN_KEY, "true");
}
